import { makeStyles } from "@material-ui/core";
import styles from "./../Functions.module.css";
import { useEffect, useState } from "react";
import InputParameters from "./InputParameters";
import OutputParameters from "./OutputParameters";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@material-ui/core";
import { GetState, GetStateFromData } from "../../../components/CustomHooks/CustomHooks";
import {ReactComponent as NoRightsIllustration} from "../../../Icons/NoRightsIllustration.svg"
import { updateStateInRedux } from "../../../Redux";
import { formStateStore } from "../../../Redux/Store/store";


const useStyles = makeStyles(() => ({
  table: {
    minWidth: 620,
  },
  bodyTab1: {
    textAlign:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "right"
        : "left",
    font: "normal normal 600 12px/17px Open Sans;",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
  },
  tab: {
    marginRight:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "0px"
        : "40px",
    marginLeft:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "40px"
        : "0px",
    verticalAlign: "middle",
    cursor: "pointer",
  },
  activeTab: {
    color: "var(--brand_color2)",
    paddingBottom: "7px",
    borderBottom: "3px solid var(--brand_color2)",
    marginRight:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "0px"
        : "40px",
    marginLeft:
      window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA"
        ? "40px"
        : "0px",
    verticalAlign: "middle",
    cursor: "pointer",
  },
  dialogContent: {
    width: "100%",
    justifyContent: "space-between",
    fontFamily: "Open Sans !important",
    fontSize: "14px !important",
  },
}));

function showLabel(name, type, unbounded, desc) {
  if (type === "0" || type === "11") {
    return (
      <span style={{ fontSize: "12px", fontWeight: "bold" }} title={desc === "" ? null : desc}>
        {name.charAt(0).toUpperCase() + name.slice(1)}
        <span style={{ fontSize: "10px", marginLeft: "10px", color: "black" }}>
          {unbounded === "Y" ? "(Array)" : ""}
        </span>
      </span>
    );
  } else {
    return (
      <span title={desc === "" ? null : desc}>
        {name.charAt(0).toUpperCase() + name.slice(1)}
        <span style={{ fontSize: "10px", marginLeft: "10px", color: "black" }}>
          ({type})
        </span>
      </span>
    );
  }
}

function createModifiedJSON(obj, tempName = "", varName = "") {
  for (let item of obj) {
    item.label = item?.VariableName
      ? showLabel(item?.VariableName, item?.VariableType, item?.Unbounded, item?.VariableDesc)
      : item?.label;
    item.value = tempName === "" ? (item?.SystemDefinedName ? item?.SystemDefinedName : item?.VariableName) : `${tempName}.${item?.SystemDefinedName ? item?.SystemDefinedName : item?.VariableName}`  || item?.value;
    // item.VariableDesc = item?.VariableDesc;
    item.SystemDefinedName = item.SystemDefinedName ? item.SystemDefinedName : item?.VariableName;
    item.VarName = varName === "" ? item?.VariableName : `${varName}.${item?.VariableName}` || item?.VarName
    // item.VariableName = item?.VariableName
    // item.VariableType = item?.VariableType;
    // item.Unbounded = item?.Unbounded;
    // item.VariableDesc = item?.VariableDesc
    item.disabled = (item.isParentTable && item.isParentTable === "Y") ? true : false || item?.disabled
    delete item?.treeName;
    // item.VariableId = item?.VariableId;
    delete item?.dataObjectType;
    // item.MappingInfo = item?.MappingInfo;
    delete item?.parentName;
    delete item?.VariableLength;
    delete item?.VarPrecision;
    delete item?.isMapped;

    if (item?.children && item?.children.length > 0) {
      createModifiedJSON(item?.children, item?.value, item?.VarName);
    }
  }
}

const DefineParameters = ({
  isMF,
  prevValue,
  inputDataObjects,
  setInputDataObjects,
  outputDataObjects,
  setOutputDataObjects,
}) => {
  const { t } = useTranslation(["styles", "translation"]);

  const [activeTab, setActiveTab] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState(true);
  const { listOfDataObjects, bfProcessName, isBFChanged } = GetState("listOfDataObjects", "bfProcessName", "isBFChanged");

  const contexts = GetStateFromData();
  const { filteredDataObject } = contexts.contexts;
  let copyData = [...filteredDataObject];
  let flag = true
  
  if(flag){
    let t = ""
    createModifiedJSON(copyData, t)
    flag = false
  }
  useEffect(() => {
    const { filteredDataObject } = contexts.contexts;
    let copyData = [...filteredDataObject];
    let t = ""
    createModifiedJSON(copyData, t);
  }, [isMF, inputDataObjects, outputDataObjects]);

  useEffect(() => {
    setOpen(true)
    setDisplay(true)
    setTimeout(() => {
      if(filteredDataObject.length > 0){
        setActiveTab("INPUT")
        setIsDataLoaded(true)
        setOpen(false)
        setDisplay(false)
        formStateStore.dispatch(updateStateInRedux({name: "isBFChanged", value: false}))
      } else if(listOfDataObjects.length > 0 || bfProcessName.length > 0){
        setActiveTab("")
        setOpen(false)
        setDisplay(false)
        formStateStore.dispatch(updateStateInRedux({name: "isBFChanged", value: false}))
      }
    }, isMF ? 5000 : 500)
  }, [filteredDataObject, filteredDataObject[0]?.VariableName, listOfDataObjects, bfProcessName])

  const handleTab = (tab) => {
    setActiveTab(tab);
  };

  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";

  const classes = useStyles();

  return (
    <>
          <div style={{ height: "40px", fontWeight: "bold" }}>
            <div style={{ display: "flex", marginTop: "10px" }}>
              <h4 className={styles.parameterHeader}>{t("translation:Define_Parameters")}</h4>
              <div className={styles.horizontalLine}></div>
            </div>
          </div>

          <div style={{ fontWeight: "bold" }}>
            <div
              className={classes.bodyTab1}
              style={translationStyles1 ? { display: "flex" } : null}
            >
              <span
                className={
                  activeTab === "INPUT" ? classes.activeTab : classes.tab
                }
                tabIndex={0}
                onClick={() => handleTab("INPUT")}
              >
                {t("translation:Input_Parameters")}
              </span>
              <span
                className={
                  activeTab === "OUTPUT" ? classes.activeTab : classes.tab
                }
                tabIndex={0}
                onClick={() => handleTab("OUTPUT")}
              >
                {t("translation:Output_Parameters")}
              </span>
            </div>
          </div>
          <div style={{ fontWeight: "bold" }}>
            {open ? 
              <div className={styles.inputBody}>
                {display &&  
                <div style={{display: 'flex', position: 'relative', zIndex: '2', height:'100%', justifyContent: 'center', alignItems: 'center'}}>
                  {open && <CircularProgress size={30}><h6 style={{color:`var(--brand_color2)`}}>Loading Data Objects</h6></CircularProgress>}
                </div>
                }
              </div>
              :
              activeTab === "" ? 
              <div className={styles.inputBody}>
                {filteredDataObject.length > 0 ? 
                <span style={{display: "block", textAlign: "center", marginTop: "10%"}}>`${t("translation:Loading_Data_Objects")}...</span>
                :
                <>
                  {!isBFChanged && 
                    <>
                    <span className={styles.centerAlligned}>
                      <NoRightsIllustration />
                    </span>
                    <span className={styles.centerAlligned} style={{top: '16px'}}>{t("translation:No Rights Associated")}</span>
                    {listOfDataObjects?.length > 0 &&
                    <span className={styles.noRigthsLabel}>
                      {t("translation:Access to the data object")} [
                      {listOfDataObjects.map((val, idx) => (
                        <span key={idx} style={{fontWeight: 'Bold'}}>{val}{idx < listOfDataObjects.length - 1 ? ", " : ""}</span>
                      ))}
                      ] {t("translation:Restricted_Data_Objects_Msg")}
                    </span>
                    }
                    {bfProcessName?.length > 0 &&
                    <span className={styles.noRigthsLabel}>
                      {t("translation:Access to the process")} [ <span style={{fontWeight: 'Bold'}}>{bfProcessName}</span> ] {t("translation:Restricted_Data_Objects_Msg")}
                    </span>
                    }
                  </>
                  }
                </>                
                }
              </div> :
              activeTab === "INPUT" ? (
                <InputParameters
                  isMF={isMF}
                  DO={copyData}
                  inputDataObjects={inputDataObjects}
                  setInputDataObjects={setInputDataObjects}
                  prevValue={prevValue}
                  isDataLoaded={isDataLoaded}
                  setIsDataLoaded={setIsDataLoaded}
                />
              ) : (
                <OutputParameters
                  isMF={isMF}  
                  DO={copyData}
                  outputDataObjects={outputDataObjects}
                  setOutputDataObjects={setOutputDataObjects}
                  prevValue={prevValue}
                  isDataLoaded={isDataLoaded}
                  setIsDataLoaded={setIsDataLoaded}
                />
              )}
          </div>
        </>
      )}

export default DefineParameters;
